import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePdfLoading = defineStore('pdfLoading', () => {
    const visible = ref(false)
    const progress = ref(0)
    const text = ref('正在生成 PDF，請稍候...')

    function show(msg = '正在生成 PDF，請稍候...') {
        visible.value = true
        progress.value = 0
        text.value = msg
    }

    function hide() {
        visible.value = false
        progress.value = 0
    }

    function setProgress(val) {
        progress.value = Math.min(100, Math.max(0, val))
    }

    return { visible, progress, text, show, hide, setProgress }
})
